import { UserStore } from './user';
import { GeneralStore } from './general';
import { ProductExceptionsStore } from './productExceptions';
import { MaxDiscountsStore } from './maxDiscounts';
import { MinMarginsStore } from './minMargins';
import { PricingRulesStore } from './pricingRules';
import { PricingRulesVpStore } from './pricingRulesVp';
import { TopNCategoriesStore } from './topNCategories';
import { DashboardReportsStore } from './dashboardReports';
import { DashboardProductsStore } from './dashboardProducts';
import { DashboardProductsVpStore } from './dashboardProductsVp';
import { ConfigurationStore } from './configuration';

export interface StoreModel {
  user: UserStore;
  general: GeneralStore;
  productExceptions: ProductExceptionsStore;
  configuration: ConfigurationStore;
  maxDiscounts: MaxDiscountsStore;
  minMargins: MinMarginsStore;
  pricingRules: PricingRulesStore;
  pricingRulesVp: PricingRulesVpStore;
  topNCategories: TopNCategoriesStore;
  dashboardReports: DashboardReportsStore;
  dashboardProducts: DashboardProductsStore;
  dashboardProductsVp: DashboardProductsVpStore;
}

export enum Mode {
  VIEW,
  CREATE,
  EDIT,
}
